import { Toaster as Sonner, toast } from "sonner";
import { useDarkModeContext } from "@/contexts/DarkModeContext";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { isDark } = useDarkModeContext();

  return (
    <Sonner
      theme={isDark ? "dark" : "light"}
      className="toaster group"
      position="bottom-right"
      duration={4000}
      closeButton
      richColors
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:rounded-lg",
          title:
            "group-[.toast]:font-heading group-[.toast]:font-semibold group-[.toast]:text-sm group-[.toast]:leading-snug group-[.toast]:tracking-tight group-[.toast]:text-balance",
          description:
            "group-[.toast]:text-sm group-[.toast]:leading-body group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:text-btn-sm group-[.toast]:font-semibold",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:text-btn-sm group-[.toast]:font-semibold",
          success: "group-[.toaster]:bg-primary/10 group-[.toaster]:border-primary/20",
          error: "group-[.toaster]:bg-destructive/10 group-[.toaster]:border-destructive/20",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
